import React, { useState, useEffect, useCallback } from "react";
import { Table, Row, Col, Card, Divider, Switch, Skeleton, Empty } from "antd";
import { IconButton } from "../../components/Buttons/buttons";
import { EyeFilled, EditOutlined } from "@ant-design/icons";
import * as InstallerData from "../../services/InstallerData";
import * as Clientsrvices from "../../services/AllClients";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const InstallerDatatable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [installers, setInstallers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchInstallerData = useCallback(() => {
    setLoading(true);
    dispatch(InstallerData.getInstallerListing())
      .then((res) => {
        setInstallers(Array.isArray(res) ? res : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [dispatch]);

  useEffect(() => {
    fetchInstallerData();
    window.scrollTo(0, 0);
  }, [fetchInstallerData, page, pageSize]);

  const handleToggleStatus = (status, id) => {
    Swal.fire({
      icon: "warning",
      title: "Are You Sure?",
      confirmButtonText: "Yes",
      showDenyButton: true,
      denyButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        updateStatus(status, id);
      } else if (result.isDenied) {
        Swal.fire({
          icon: "info",
          text: status ? "Installer Not Enabled." : "Installer Not Disabled.",
        });
      }
    });
  };

  const updateStatus = (status, id) => {
    setLoading(true);
    const vals = { id, val: status };
    dispatch(Clientsrvices.disable_client(vals))
      .then(() => {
        const updatedInstallers = installers.map((item) =>
          item.user_id === id ? { ...item, user_status: status ? "0" : "1" } : item
        );
        setInstallers(updatedInstallers);
        Swal.fire({
          icon: "success",
          title: status ? "Enabled!" : "Disabled!",
          text: `Installer has been ${status ? "enabled" : "disabled"}.`,
        });
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const columns = [
    {
      title: "Installer ID",
      dataIndex: "user_id",
      key: "user_id",
    },
    {
      title: "Installer Name",
      dataIndex: "fullname",
      key: "fullname",
      sorter: (a, b) => a.fullname.localeCompare(b.fullname),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Location",
      key: "location",
      render: (_, record) => {
        const loc = [record.city, record.state].filter(Boolean).join(", ");
        return loc || "-";
      },
    },
    {
      title: "Status",
      dataIndex: "user_status",
      key: "user_status",
      render: (status, record) => (
        <Switch
          checkedChildren="ENABLE"
          unCheckedChildren="DISABLE"
          checked={status === "1" ? false : true}
          onChange={(checked) => handleToggleStatus(checked, record.user_id)}
        />
      ),
    },
    {
      title: "Action",
      key: "Action",
      render: (_, record) => (
        <div className="d-flex gap-2">
          <IconButton
            icon={<EyeFilled />}
            type="primary"
            tooltip="View"
            text="View"
            handleClick={() => navigate(`/single-installer/?user_id=${record.user_id}`)}
          />
          <IconButton
            icon={<EditOutlined />}
            type="secondary"
            tooltip="Edit"
            text="Edit"
            handleClick={() => navigate(`/installer-update/?user_id=${record.user_id}`)}
          />
        </div>
      ),
    },
  ];

  return (
    <Card className="reportCard">
      <Row gutter={16}>
        <Col>
          <div className="d-flex align-items-center">
            <h3 style={{ fontSize: "18px", fontWeight: 600, color: "#0f172a", margin: 0, letterSpacing: "-0.2px" }}>
              Installers Listing
            </h3>
          </div>
          <div>
            <p style={{ fontSize: "13.5px", color: "#64748b", fontWeight: 500, margin: "2px 0 0 0" }}>
              {installers.length} Installers
            </p>
          </div>
        </Col>
      </Row>

      <Divider />
      <Table
        bordered
        className="clientsDataTable py-0"
        tableLayout="auto"
        scroll={{ x: 1000 }}
        columns={columns}
        dataSource={installers}
        rowKey="user_id"
        loading={loading}
        locale={{
          emptyText: loading ? (
            <Skeleton.Input
              style={{ marginTop: "2px", height: "48px", padding: "0px" }}
              block
              active
            />
          ) : (
            <Empty description="No Installers found" />
          ),
        }}
        pagination={{
          current: page,
          pageSize,
          onChange: (newPage, newPageSize) => {
            setPage(newPage);
            setPageSize(newPageSize);
          },
          position: ["bottomCenter"],
        }}
      />
    </Card>
  );
};

export default InstallerDatatable;
